import { FC } from "react";

import { t } from "i18n/i18n";
import { AccordionTitle } from "mds/components/AccordionTitle";

export const EngagementTableDisclaimer: FC = () => {
  return (
    <div className="disclaimer body-s mt-2 flex flex-col gap-4 text-black-tint-40">
      <AccordionTitle
        className="px-4 py-1"
        headerClassName="w-full justify-between"
        iconPosition="end"
        title={t("engagement_table.disclaimer.student_usage")}
        showBorder
      >
        <div className="flex flex-col gap-2 py-2">
          {t("engagement_table.disclaimer.intro", {
            returnObjects: true,
          }).map((item) => (
            <div key={item}>{item}</div>
          ))}

          <div className="font-bold">{t("engagement_table.disclaimer.sampling_title")}</div>
          <div>{t("engagement_table.disclaimer.sampling_body")}</div>

          <div className="font-bold">{t("engagement_table.disclaimer.measuring_title")}</div>
          {t("engagement_table.disclaimer.measuring_body", {
            returnObjects: true,
          }).map((item) => (
            <div key={item}>{item}</div>
          ))}
        </div>
      </AccordionTitle>

      <AccordionTitle
        className="px-4 py-1"
        headerClassName="w-full justify-between"
        iconPosition="end"
        title={t("engagement_table.disclaimer.best_practices")}
        showBorder
      >
        <div className="flex flex-col gap-2 py-2">
          <div className="font-bold">{t("engagement_table.disclaimer.low_score_title")}</div>
          <ol className="list-decimal pl-4">
            {t("engagement_table.disclaimer.low_score_statements", {
              returnObjects: true,
            }).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>

          <div className="font-bold">{t("engagement_table.disclaimer.high_risk_title")}</div>
          <ol className="list-decimal pl-4">
            {t("engagement_table.disclaimer.high_risk_statements", {
              returnObjects: true,
            }).map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ol>
        </div>
      </AccordionTitle>
    </div>
  );
};
